import React, { useState, useEffect } from "react";
import { Input, FormGroup, Label, Button } from "reactstrap";
import { useNavigate, useParams } from "react-router-dom";
import axios from "axios";
import { toast } from "react-toastify";

const STATE_HEADER_TYPES = [
  "Overview",
  "Popular Destinations",
  "Things to See & Do",
  "Featured Experience",
  "Check This Out",
];

const EditStateHeader = () => {
  const { id } = useParams();
  const { token } = JSON.parse(localStorage.getItem("auth") || "{}");
  const navigate = useNavigate();
  const [formData, setFormData] = useState({
    state_id: "",
    name: "",
    parent_id: "",
    status: 1,
  });
  const [states, setStates] = useState([]);
  const [parentOptions, setParentOptions] = useState([]);
  const [errors, setErrors] = useState({});
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    axios
      .get(`/api/admin/v1/state-header-list/${id}`, {
        headers: { Authorization: `Bearer ${token}` },
      })
      .then((res) => {
        const h = res.data?.stateHeader;
        if (h) {
          setFormData({
            state_id: h.state_id || "",
            name: h.name || "",
            parent_id: h.parent_id || "",
            status: h.status ?? 1,
          });
        }
      })
      .catch(() => toast.error("Failed to load state header"))
      .finally(() => setLoading(false));
  }, [id]);

  useEffect(() => {
    axios
      .get("/api/admin/v1/state-lists?limit=500&page=0", {
        headers: { Authorization: `Bearer ${token}` },
      })
      .then((res) => {
        const data = res.data?.StateLists || res.data?.states || [];
        setStates(data);
      })
      .catch(() => {});
  }, []);

  useEffect(() => {
    if (!formData.state_id) {
      setParentOptions([]);
      return;
    }
    axios
      .get(
        `/api/admin/v1/state-header-list/options?state_id=${formData.state_id}`,
        { headers: { Authorization: `Bearer ${token}` } }
      )
      .then((res) => {
        const list = res.data?.stateHeaders || [];
        setParentOptions(list.filter((h) => !h.parent_id && h.id !== parseInt(id, 10)));
      })
      .catch(() => setParentOptions([]));
  }, [formData.state_id, id]);

  const inputHandler = (e) => {
    const { name, value } = e.target;
    if (name === "status") {
      setFormData((prev) => ({ ...prev, [name]: e.target.checked ? 1 : 0 }));
    } else {
      setFormData((prev) => ({ ...prev, [name]: value }));
    }
    if (errors[name]) setErrors((prev) => ({ ...prev, [name]: null }));
  };

  const handleSubmit = () => {
    const err = {};
    if (!formData.state_id) err.state_id = "State is required.";
    if (!formData.name) err.name = "Header type is required.";
    setErrors(err);
    if (Object.keys(err).length) return;

    axios
      .put(`/api/admin/v1/state-header-list/${id}`, formData, {
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
        },
      })
      .then((res) => {
        toast.success(res.data?.message || "State header updated successfully.");
        navigate("/state-headers");
      })
      .catch((err) => {
        toast.error(
          err.response?.data?.message || "Something went wrong"
        );
        setErrors(err.response?.data || {});
      });
  };

  if (loading) {
    return (
      <div className="text-white p-4">Loading...</div>
    );
  }

  return (
    <div>
      <div className="row my-3">
        <div className="col-md-12">
          <h4 className="text-white">Edit State Header</h4>
        </div>
      </div>
      <div className="bg-white px-3 py-4 rounded-2 my-4">
        <div className="row">
          <div className="col-md-4 offset-md-1">
            <FormGroup>
              <Label>
                State <span className="text-danger">*</span>
              </Label>
              <Input
                value={formData.state_id}
                type="select"
                name="state_id"
                onChange={inputHandler}
              >
                <option value="">Select State</option>
                {states.map((s) => (
                  <option key={s.id} value={s.id}>
                    {s.state_name}
                  </option>
                ))}
              </Input>
              <span className="d-block text-danger">{errors?.state_id}</span>
            </FormGroup>
          </div>
          <div className="col-md-4 offset-md-1">
            <FormGroup>
              <Label>
                Header Type <span className="text-danger">*</span>
              </Label>
              <Input
                value={formData.name}
                type="select"
                name="name"
                onChange={inputHandler}
              >
                <option value="">Select Type</option>
                {STATE_HEADER_TYPES.map((type) => (
                  <option key={type} value={type}>
                    {type}
                  </option>
                ))}
              </Input>
              <span className="d-block text-danger">{errors?.name}</span>
            </FormGroup>
          </div>
          <div className="col-md-4 offset-md-1">
            <FormGroup>
              <Label>Parent Header (Sub-header)</Label>
              <Input
                value={formData.parent_id}
                type="select"
                name="parent_id"
                onChange={inputHandler}
              >
                <option value="">None (main header)</option>
                {parentOptions.map((h) => (
                  <option key={h.id} value={h.id}>
                    {h.name}
                  </option>
                ))}
              </Input>
            </FormGroup>
          </div>
          <div className="col-md-4 offset-md-1">
            <FormGroup switch>
              <Input
                type="switch"
                checked={!!formData.status}
                onChange={inputHandler}
                name="status"
              />
              <Label check>Status (Active)</Label>
            </FormGroup>
          </div>
          <div className="col-md-4 offset-md-4 mt-3">
            <Button color="primary" onClick={handleSubmit}>
              Update
            </Button>
            <Button className="ms-3" onClick={() => navigate("/state-headers")}>
              Cancel
            </Button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default EditStateHeader;
